import { EmptyState } from 'ui/emptyState';
import { ListsEmptyState } from 'ui/illustrations';
import { EmptyStateWrapper } from '../../AudienceSelection.styled';

export const NO_SEARCH_MATCHES_TITLE = 'No matching lists';
export const NO_SEARCH_MATCHES_SUBTITLE =
  'Try a different list type or searching by different keywords.';

export const SearchEmptyState = () => (
  <EmptyStateWrapper data-test="campaign-editor-search-empty-state">
    <EmptyState
      Illustration={ListsEmptyState}
      title={NO_SEARCH_MATCHES_TITLE}
      subtitle={NO_SEARCH_MATCHES_SUBTITLE}
    />
  </EmptyStateWrapper>
);
